"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeOutcomesSchema = exports.EventWithRelsWithoutAttributesSchema = exports.EventWithRelsSchema = exports.EventLocationFieldsSchema = exports.EventWithoutAttributesSchema = exports.EventSchema = exports.EventMarkerSchema = void 0;
const zod_1 = require("zod");
const player_1 = require("./player");
const team_1 = require("./team");
const competition_1 = require("./competition");
const season_1 = require("./season");
const game_1 = require("./game");
const query_1 = require("./query");
const userGame_1 = require("./userGame");
exports.EventMarkerSchema = zod_1.z.object({
    event_id: zod_1.z.string(),
    type: zod_1.z.string(),
    video_event_id: zod_1.z.string().nullable(),
    minute: zod_1.z.number().nullable().optional(),
    second: zod_1.z.number().nullable().optional(),
    start_x: zod_1.z.number().nullable(),
    start_y: zod_1.z.number().nullable(),
    end_x: zod_1.z.number().nullable().optional(),
    end_y: zod_1.z.number().nullable().optional(),
    outcome: zod_1.z.string().nullable(),
    xg: zod_1.z.number().nullable().optional(),
    penalty: zod_1.z.boolean(),
    free_kick: zod_1.z.boolean(),
    body_part: zod_1.z.string().nullable(),
    player_display_name: zod_1.z.string(),
    game_name: zod_1.z.string().nullable(),
    competition_name: zod_1.z.string(),
    season_name: zod_1.z.string(),
    game_date: zod_1.z.string(),
    game_id: zod_1.z.number(),
    follows_dribble: zod_1.z.boolean(),
    follows_through_ball: zod_1.z.boolean(),
    has_video: zod_1.z.boolean(),
});
exports.EventSchema = zod_1.z.object({
    event_id: zod_1.z.string(),
    type: zod_1.z.string(),
    index: zod_1.z.number(),
    game_id: zod_1.z.number(),
    competition_id: zod_1.z.number(),
    season_id: zod_1.z.number(),
    cycle_id: zod_1.z.number(),
    period: zod_1.z.number().nullable(),
    team_id: zod_1.z.number().nullable(),
    opposition_team_id: zod_1.z.number().nullable(),
    player_id: zod_1.z.number().nullable(),
    video_timestamp: zod_1.z.number().nullable(),
    game_time: zod_1.z.string().nullable(),
    period_time: zod_1.z.string().nullable(),
    x: zod_1.z.number().nullable(),
    y: zod_1.z.number().nullable(),
    z: zod_1.z.number().nullable(),
    attributes: zod_1.z.record(zod_1.z.any()),
});
exports.EventWithoutAttributesSchema = exports.EventSchema.omit({ attributes: true });
exports.EventLocationFieldsSchema = zod_1.z.object({
    'event.start': query_1.SpatialSchema,
    'event.end': query_1.SpatialSchema,
});
exports.EventWithRelsSchema = zod_1.z.object({
    event: exports.EventSchema,
    player: player_1.PlayerSchema,
    team: team_1.TeamSchema,
    competition: competition_1.CompetitionSchema,
    season: season_1.SeasonSchema,
    game: game_1.GameSchema,
    recipient_player: player_1.PlayerSchema.nullable(),
    user_game: userGame_1.UserGameSchema,
});
exports.EventWithRelsWithoutAttributesSchema = zod_1.z.object({
    event: exports.EventWithoutAttributesSchema,
    player: player_1.PlayerSchema,
    team: team_1.TeamSchema,
    competition: competition_1.CompetitionSchema,
    season: season_1.SeasonSchema,
    game: game_1.GameSchema,
    recipient_player: player_1.PlayerSchema.nullable(),
    user_game: userGame_1.UserGameSchema,
});
exports.EventTypeOutcomesSchema = zod_1.z.object({
    type: zod_1.z.string(),
    outcomes: zod_1.z.array(zod_1.z.string()),
});
//# sourceMappingURL=event.js.map